import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail1Sparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEmail1Sparkle"><Path d="M21.5 12V4.5H2.5V19.5H13" stroke="currentColor"/><Path d="M21.5 5.22705L12 12.9998L2.5 5.22705" stroke="currentColor"/><Path d="M19.4 14H18.6L17.6 16.6L15 17.6V18.4L17.6 19.4L18.6 22H19.4L20.4 19.4L23 18.4V17.6L20.4 16.6L19.4 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail1Sparkle;
